import { useQuery } from '@tanstack/react-query';
import BackSection from "../Services/BackSection";
import NoTasksDisplay from "./NoTasksDisplay";
import LoadingAssignment from "../LoadingPages/LoadingAssignment";
import AssignmentsTable from "./AssignmentsTable";
import css from './style.module.css';
import { fetchAssignments } from './AssignmentsApi';

export default function Assignments() {
    const { data: assignments, isLoading, error } = useQuery({
        queryKey: ['assignments'],
        queryFn: fetchAssignments,
        staleTime: 2 * 60 * 1000, // 2 minutes - assignments change moderately
        refetchOnWindowFocus: true,
        retry: 2,
    });

    if (isLoading) {
        return (
            <>
                <BackSection pageName="Assignments" to={"/policies"} />
                <LoadingAssignment />
            </>
        );
    }

    if (error) {
        return (
            <>
                <BackSection pageName="Assignments" to={"/policies"} />
                <div className={css.errorContainer}>
                    <div className={css.errorIcon}>⚠️</div>
                    <h2 className={css.errorTitle}>Something went wrong</h2>
                    <p className={css.errorMessage}>
                        {error.message || "Unable to load assignments"}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className={css.retryButton}
                    >
                        Try Again
                    </button>
                </div>
            </>
        );
    }

    return (
        <section>
            <BackSection pageName="Assignments" to={"/policies"} />
            <div className="ms-1 p-0">
                {assignments && assignments.length > 0 ? (
                    <AssignmentsTable assignments={assignments} />
                ) : (
                    <NoTasksDisplay />
                )}
            </div>
        </section>
    );
}